<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>错题集</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="科目类别：">
                <el-select clearable v-model="formInline.courseCategoryId">
                    <el-option v-for="item in courseList" :key="item.courseCategoryId" :label="item.courseCategoryName"
                        :value="item.courseCategoryId"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button size="small" type="primary" :disabled="!tableForm.tableData.length"
                    v-buttonAuth="'system:errorSet:underway'" @click="handleEdit(1)">错题训练</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData"
                :loading="tableForm.isLoading">
                <el-table-column prop="userSex" width="380px" label="操作">
                    <template slot-scope="scope">
                        <div class="d-flex fz14 col-29f cs-pit">
                            <el-button type="text" class="col-29f operate"
                                @click="handleEdit(2, scope.row)">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog :title="title" :visible.sync="editFormVisible" custom-class="form-dialog" width="40%"
            @before-close='editFormVisible = false'>
            <div class="question-title">{{ questionDetails.questionTopic }}（）</div>
            <div class="mg-tp10" v-if="questionDetails.questionImg">
                <img :src="questionDetails.questionImg" style="width: 200px;margin-bottom: 10px;" alt="" srcset="">
            </div>

            <template v-if="questionDetails.questionType === 3">
                <el-radio-group disabled>
                    <el-radio-button :label="true">正确</el-radio-button>
                    <el-radio-button :label="false">错误</el-radio-button>
                </el-radio-group>
            </template>

            <template v-else>
                <div v-for="(value, key, index) of questionDetails.questionOption" :key="key"
                    class="d-flex flex-align-center option-from">
                    <span>{{ key }}、</span>
                    <span>
                        {{ questionDetails.questionOption[key]
                        }}</span>
                </div>
            </template>

            <div class="question-desc mg-tp20">我的答案：

                <template v-if="questionDetails.questionType === 3">
                    {{ questionDetails.myAnswer == null ? '-' : JSON.parse(questionDetails.myAnswer) ? '正确' : '错误' }}
                </template>

                <template v-else>
                    {{ questionDetails.myAnswer }}
                </template>
            </div>
            <div class="question-desc">正确答案：

                <template v-if="questionDetails.questionType === 3">
                    {{ JSON.parse(questionDetails.questionAnswer )== null ? '-' : JSON.parse(questionDetails.questionAnswer) ? '正确' : '错误' }}
                </template>

                <template v-else>
                    {{ questionDetails.questionAnswer }}
                </template>
            </div>
            <div class="question-desc">题目解析：{{ questionDetails.questionAnalysis || '无' }}</div>
            <div class="question-desc">科目类别：{{ questionDetails.courseCategoryName }}</div>
        </el-dialog>
    </div>
</template>

<script>
import courseApi from '@/api/onlineTraining/classification.js'
import { mistakesPage } from '@/api/mistakes.js'
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
export default {
    components: {
        MyTable,
        Pagination,
    },
    data () {
        return {
            courseList: [],
            formInline: {
                courseCategoryId: '',
            },
            tableForm: {
                customColumns: [
                    { label: '科目类别', prop: 'question', formatter: (item) => { return item.courseCategoryName } },
                    { label: '题目类型', prop: 'question', formatter: (item) => { return item.questionTypeText } },
                    { label: '题目内容', prop: 'question', formatter: (item) => { return item.questionTopic } },
                    { label: '题目解析', prop: 'question', formatter: (item) => { return item.questionAnalysis } },
                ],
                tableData: [],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            questionDetails: {
                questionOption: {}
            },
            title: '',
            editFormVisible: false,
        }
    },
    created () {
        this.getDictionary();
        this.getData();
    },
    methods: {
        async getDictionary () {
            const courseRes = (await courseApi.courseCategoryList({ pageNum: 1, pageSize: 999999, stateSign: true })).data;
            this.courseList = courseRes;
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData();

        },

        search () {
            this.pageparm.currentPage = 1
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = await mistakesPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        handleEdit (type, row) {
            if (type == 1) {
                this.$router.push({
                    path: '/errorSet/train',
                })
                this.title = '错题训练';
            }
            if (type == 2) {
                this.questionDetails = row.question;
                this.questionDetails.myAnswer = row.myAnswer
                this.title = row.question.questionTypeText + '题';
                this.editFormVisible = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.question-title {
    font-size: 18px;
    margin-bottom: 10px;
    color: #333333;
}

.question-desc {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/views/errorSet/list.vue